module.exports = __webpack_public_path__ + "img/temp-3-header.83afff05.png";